import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContestanddrawingRoutingModule } from './contestanddrawing-routing.module';
import { FancastComponent } from './components/fancast/fancast.component';
import { PickscoreComponent } from './components/pickscore/pickscore.component';
import { DrawingcontestComponent } from './components/drawingcontest/drawingcontest.component';
import { AllcontestComponent } from './components/allcontest/allcontest.component';
import { FilmcontestComponent } from './components/filmcontest/filmcontest.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DrawingmainComponent } from './components/drawingmain/drawingmain.component';

import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DrawingReceiptComponent } from './components/drawing-receipt/drawing-receipt.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StarRateComponent } from './components/star-rate/star-rate.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
 
@NgModule({
  declarations: [
    FancastComponent,
    PickscoreComponent,
    DrawingcontestComponent,
    AllcontestComponent,
    FilmcontestComponent,
    DrawingmainComponent,
    DrawingReceiptComponent,
    StarRateComponent,



  ],
  imports: [
    CommonModule,
    ContestanddrawingRoutingModule,
    CarouselModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatIconModule,
  ],
  providers: [MatIconRegistry]

})
export class ContestanddrawingModule { 

  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    // Register the 'star' and 'star_border' icons as SVGs
    this.matIconRegistry.addSvgIcon('star', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/star.svg'));
    this.matIconRegistry.addSvgIcon('star_border', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/star_outline.svg'));
  }
  
}
